// extracted by mini-css-extract-plugin
export default {"bankOptionsWrapper":"pkc9c9mGNUIH9ctQuLYZ","bankOption":"kzEK1_1e_42u87CLnwTO","bankOptionLogoContainer":"wAakiVonzPC1DFldjCnF","bankOptionLogo":"gJCrCPJlA4JWUfJl20ez"};